module.exports = __webpack_public_path__ + "img/setting.ec4a30d9.png";